<script>
export default {
  name: "ConsentText",
  props: {
    showSvg: {
      type: Boolean,
      default: true
    },
    toggleChecked: {
      type: Function,
      default: null
    }
  }
}
</script>

<template>
  <span>
  </span>
</template>

<style scoped lang="scss">
p,span{
  font-size:13px;
  color:#333333;
  margin-bottom:5px;
}

</style>
